import { motion, useReducedMotion } from 'motion/react';

import { PAGE_REVEAL_EASE, WEEK_PILLS_REVEAL } from '../constants/pageReveal.constants';
import { WEEK_TABS } from '../constants/weekTabs.constants';

export default function WeekPills({
  selectedIndex,
  onSelect,
}: {
  selectedIndex: number;
  onSelect: (index: number) => void;
}) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className="flex justify-center"
      initial={reduceMotion ? false : { opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: reduceMotion ? 0.01 : WEEK_PILLS_REVEAL.duration,
        delay: reduceMotion ? 0 : WEEK_PILLS_REVEAL.delay,
        ease: PAGE_REVEAL_EASE,
      }}
    >
      <div
        role="tablist"
        aria-label="Select week"
        className="inline-flex overflow-hidden rounded-full border border-slate-900/[0.08] bg-[#ede8db] p-1"
      >
        {WEEK_TABS.map(({ index, label }) => {
          const isSelected = selectedIndex === index;

          return (
            <button
              key={label}
              type="button"
              role="tab"
              aria-selected={isSelected}
              onClick={() => onSelect(index)}
              className={`inline-flex shrink-0 items-center justify-center rounded-full px-3 py-1 text-[13px] tracking-[-0.01em] transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 ${
                isSelected
                  ? 'bg-white font-semibold text-slate-900 shadow-sm'
                  : 'font-medium text-slate-600 hover:bg-white/50 hover:text-slate-900'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </motion.div>
  );
}
